import { makeRequest } from './makeRequest';
import { warn } from '../utils/logger';
import { clientServerErrorTracking } from '../actions/analyticsActions';
import {
    call, spawn, put
} from 'redux-saga/effects';

export function* tryCatchSaga(route, options) {
    try{
        const response = yield call(makeRequest, route);
        if(options.successSaga) {
            yield spawn([options, options.successSaga], response, route, options);
        } else {
            warn('You did not supply a success saga');
        }
    } catch (err) {
        // Dispatch action to track error
        const errorSlug = _.get(err, 'entity.code', _.get(err, 'status.code', 'GENERAL_ERROR'));

        yield put(clientServerErrorTracking(errorSlug));

        // Handle Error
        const error = handleCatchError(err);

        if(options.failSaga) {
            yield call([options, options.failSaga], error, route, options);
        } else {
            yield call(generalFailSaga, error, route, options);
        }
    }
}

export function handleCatchError(error) {
    if(_.get(error, 'url', false) && _.get(error, 'status', false)) {
        const requestError = new Error(`${error.status.code} while retrieving ${error.url}`);
        return requestError;
    }
    return error;
}

export function* generalFailSaga(error, route, options) {
    Raven.captureException(error, {
        extra: {
            route: route
        }
    });
}
